export default __webpack_public_path__ + "static/media/sme_client.03a04e65.png";